import styled from 'styled-components';
import { Box } from 'src/viewLayer/components/DesignSystem';

export const BackButtonContainer = styled(Box)`
  left: 0;
  position: fixed;
  top: 0.625rem;
`;
